import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8d82685a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-wrapper" }
const _hoisted_2 = { class: "head-content" }
const _hoisted_3 = { class: "part-left" }
const _hoisted_4 = { class: "name-block" }
const _hoisted_5 = ["title"]
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "info-list" }
const _hoisted_8 = { class: "info-item" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "info-content" }
const _hoisted_11 = { class: "part-right" }
const _hoisted_12 = ["title"]
const _hoisted_13 = ["title"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "time-info" }
const _hoisted_16 = { class: "body-wrapper" }
const _hoisted_17 = { class: "patch-info" }
const _hoisted_18 = { class: "custom-tree-node" }
const _hoisted_19 = ["title"]

import { computed, reactive, watch } from 'vue'

import ContentAdaptLayout from '@/views/dashboard/_components/content-adapt-layout/content-adapt-layout.vue'
import TerminalHead from '@/views/dashboard/group/client/terminal-info/terminal-head/terminal-head.vue'
import { login_status } from '@/views/dashboard/response-manage/response-handle/types'
import { BaselinecheckResultSubstandardService, RequestParams } from './base-line-detail.service'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { BaseLineItem, BaseLineService } from '@/views/dashboard/safe-status/base-line/base-line.service'
import {
  AllBaseLineItemResponse,
  RepairTreeItem,
  SystemType
} from '@/views/dashboard/safe-status/base-line/repair-item-tree-type'
import {
  applyBaselineRepairDisplayNamesToTree,
  DUBA_BASELINE_REPAIR_ITEMS_KEY,
  ensureBaselineRepairItemsLoaded,
  setCustomThresholds
} from '@/views/dashboard/safe-status/base-line/baseline-repair-items-cache'
import { SystemConfigService } from '@/services/system-config.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'base-line-detail',
  props: {
    currentDevice: { default: () => ({} as BaseLineItem) },
    defaultExpand: { type: Boolean, default: true }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props

const headLoginStatus = computed(
  () => props.currentDevice.login_status ?? props.currentDevice.device_status ?? login_status.online,
)

const injector = useReflectiveInjector([BaselinecheckResultSubstandardService, BaseLineService, SystemConfigService])
const service = injector.get(BaselinecheckResultSubstandardService)
const baseLineService = injector.get(BaseLineService)
const systemConfigService = injector.get(SystemConfigService)

const viewModel = reactive({
  nums: 0,
  ALL_ITEMS: [] as RepairTreeItem[],
  substandard_ids: [] as string[],
  check_item_ids: [] as string[],
  check_time: ''
})

const queryParams = reactive<RequestParams>({
  device_id: props.currentDevice.device_id || 'fa963ddc78baba3a60cf2d5b000a73ba'
})

async function fetchCustomThresholds () {
  try {
    const res = await systemConfigService.getSystemConfig({ config_key: 'base_lime_custom' })
    if (res?.config_value) {
      const parsed = JSON.parse(res.config_value)
      if (Array.isArray(parsed)) {
        const thresholds: Record<string, number> = {}
        parsed.forEach((item: any) => {
          const parts = String(item.data_value || '').split(',').filter((p: string) => p !== '')
          const val = parseFloat(parts.length > 0 ? parts[parts.length - 1] : '')
          if (!isNaN(val)) {
            thresholds[item.item_id] = val
          }
        })
        setCustomThresholds(thresholds)
      }
    }
  } catch (e) {
    console.warn('Failed to fetch custom baseline thresholds', e)
  }
}

async function getData () {
  await ensureBaselineRepairItemsLoaded(() => baseLineService.getAllBaselineItems())
  await fetchCustomThresholds()
  service.getBaselinecheckResultSubstandard(queryParams).then(subRes => {
    viewModel.substandard_ids = subRes.substandard_ids
    viewModel.check_item_ids = subRes.check_item_ids
    viewModel.check_time = subRes.check_time
    const allItems: AllBaseLineItemResponse = JSON.parse(localStorage.getItem(DUBA_BASELINE_REPAIR_ITEMS_KEY) || '{}')
    const rawBranch = props.currentDevice.system_type === SystemType.Linux ? allItems.linux_category : allItems.category
    const branch = applyBaselineRepairDisplayNamesToTree(rawBranch)
    viewModel.ALL_ITEMS = service.generateRenderTree(branch, viewModel.check_item_ids, '')
  }).catch(() => {
    viewModel.substandard_ids = []
    viewModel.check_item_ids = []
    viewModel.check_time = ''
  })
}

watch(() => props.currentDevice.device_id, (nv, lv) => {
  if (nv && nv !== lv) {
    queryParams.device_id = nv
    getData()
  }
}, { immediate: true })

const defaultProps = {
  children: 'items',
  label: 'name'
}

const CATEGORY_ICON_CLASS: Record<string, string> = {
  1: 'category-icon--identity',
  2: 'category-icon--visit',
  3: 'category-icon--security',
  4: 'category-icon--intrusion',
  100: 'category-icon--identity',
  101: 'category-icon--visit',
  102: 'category-icon--security',
  103: 'category-icon--intrusion',
  104: 'category-icon--code',
}

function categoryIconClass (id: string) {
  return CATEGORY_ICON_CLASS[id] ?? ''
}

__expose({ getData })

return (_ctx: any,_cache: any) => {
  const _component_el_tree = _resolveComponent("el-tree")!
  const _directive_date_format = _resolveDirective("date-format")!

  return (_openBlock(), _createBlock(ContentAdaptLayout, null, {
    header: _withCtx(() => [
      _renderSlot(_ctx.$slots, "head", {
        viewModel: viewModel,
        substandard_ids: viewModel.substandard_ids,
        check_item_ids: viewModel.check_item_ids,
        check_time: viewModel.check_time,
        currentDevice: _ctx.currentDevice
      }, () => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(TerminalHead, {
            class: "base-line-detail-terminal-head",
            "system-type": _ctx.currentDevice.system_type ?? 1,
            "login-status": headLoginStatus.value
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", {
                      class: "main-info",
                      title: _ctx.currentDevice.computer_name || _ctx.$t('safeProtectionModule.terminalUnnamed')
                    }, _toDisplayString(_ctx.currentDevice.computer_name || _ctx.$t('safeProtectionModule.terminalUnnamed')), 9, _hoisted_5),
                    _createElementVNode("div", {
                      class: "other-info",
                      title: _ctx.currentDevice.system_name || '—'
                    }, _toDisplayString(_ctx.currentDevice.system_name || '—'), 9, _hoisted_6)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('safeProtectionModule.detectTime')), 1),
                      _createElementVNode("div", _hoisted_10, [
                        _withDirectives(_createElementVNode("span", null, null, 512), [
                          [_directive_date_format, { value: _ctx.currentDevice.check_time * 1000 }]
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", {
                    class: "main-info",
                    title: _ctx.currentDevice.user_mark || '—'
                  }, _toDisplayString(_ctx.currentDevice.user_mark || '—'), 9, _hoisted_12),
                  _createElementVNode("div", {
                    class: "other-info",
                    title: _ctx.currentDevice.group_name || '—'
                  }, _toDisplayString(_ctx.currentDevice.group_name || '—'), 9, _hoisted_13)
                ])
              ])
            ]),
            _: 1
          }, 8, ["system-type", "login-status"]),
          _createElementVNode("div", {
            class: _normalizeClass(["scan-detail", { 'dange-info': viewModel.substandard_ids.length > 0 }])
          }, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('safeProtectionModule.baselineScanCompleteTitle')), 1),
            _createElementVNode("p", {
              innerHTML: _ctx.$t('safeProtectionModule.baselineScanSummary', { n: viewModel.substandard_ids.length, m: viewModel.check_item_ids.length })
            }, null, 8, _hoisted_14),
            _createElementVNode("div", _hoisted_15, [
              _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.scanFinishTime')) + " ", 1),
              _withDirectives(_createElementVNode("span", null, null, 512), [
                [_directive_date_format, _ctx.currentDevice.check_time * 1000]
              ])
            ])
          ], 2)
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_el_tree, {
            data: viewModel.ALL_ITEMS,
            "node-key": "id",
            props: defaultProps,
            "check-on-click-node": "",
            "default-expanded-keys": _ctx.defaultExpand ? viewModel.substandard_ids : []
          }, {
            default: _withCtx(({ node, data }) => [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", {
                  class: _normalizeClass(["cm-ui-ml5 txt-box", !data.items ? (viewModel.substandard_ids.includes(data.id) ? 'dange' : 'safe') : ''])
                }, [
                  (data.items && categoryIconClass(data.id))
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(["category-icon", categoryIconClass(data.id)])
                      }, null, 2))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: _normalizeClass(["status-icon", viewModel.substandard_ids.includes(data.id) ? 'status-icon--dange' : 'status-icon--safe'])
                      }, null, 2)),
                  _createElementVNode("span", {
                    class: _normalizeClass(["father-name title cm-ui-ml10", ['1', '2', '3', '4', '100', '101', '102', '103', '104'].includes(data.id) ? 'title-txt' : '']),
                    title: node.label
                  }, _toDisplayString(node.label), 11, _hoisted_19)
                ], 2)
              ])
            ]),
            _: 1
          }, 8, ["data", "default-expanded-keys"])
        ])
      ])
    ]),
    _: 3
  }))
}
}

})